module.exports = __webpack_public_path__ + "img/search-waiting.40aeb0bc.svg";